const WORDS = ["Home Care", "Assisted Living", "Long-Term Care", "Hospital", "Registered Nurses", "LPN", "CNA", "GNA", "CMT", "Home Health Aides"];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {WORDS.map((w, i) => (
      <span key={w} className="flex items-center">
        <span className={`font-serif text-5xl sm:text-7xl whitespace-nowrap px-8 ${i % 2 ? "italic text-[#9B742A]" : "text-[#154F49]"}`}>{w}</span>
        <svg viewBox="0 0 24 24" className="w-6 h-6 text-[#CDA34F]" aria-hidden><path d="M12 2l2.2 7.8L22 12l-7.8 2.2L12 22l-2.2-7.8L2 12l7.8-2.2z" fill="currentColor" /></svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="py-10 sm:py-14 bg-[#EDF1E6] border-y border-[#154F49]/10 overflow-hidden no-print" data-testid="editorial-marquee" aria-label="Care settings and roles">
    <div className="marquee-track flex w-max">
      <Row /><Row hidden />
    </div>
  </section>
);
